@if (products().length > 0) {
  <section class="related-section">
    <app-product-carousel
      [products]="products()"
      [title]="title()"
      [trailingLabel]="trailingLabel()"
      [trailingLink]="trailingLink()"
      (addToCart)="addToCart.emit($event)"
      (reserveClick)="reserveClick.emit($event)"
      (zoomOpen)="zoomOpen.emit($event)"
      (notifyRequest)="notifyRequest.emit($event)"
      (notifyCancel)="notifyCancel.emit($event)"
      (cardClick)="cardClick.emit($event)"
    />
  </section>
}
